module.exports = __webpack_public_path__ + "media/images/flags/64/Jamaica-6f27e5faaecee061e3e02db9bb3a2b5e.png";